export default __webpack_public_path__ + "static/media/switchPivot.73723702.svg";